import ValueNode from '../../ValueNode';
import Type from '../../../Type';
import config from '../../../utils/config';

import type Context from 'src/Context';
import type { BaseExpression, ParentContext, Expression } from '../../../types';

export interface NotEqualsNodeT extends BaseExpression {
    $type: 'NotEqualsNode';
    value: [Expression, Expression];
}

export default class NotEqualsNode extends ValueNode<NotEqualsNodeT> {
    static TYPE = Type.NTuple(
        { key: 'a', type: 'ValueNode', suggestions: 'primitive' },
        { key: 'b', type: 'ValueNode', suggestions: 'primitive' },
    );

    static uiConfig = {
        ...config.presets.comparison,
    };

    async execute(context: Context, { sourcePath }: ParentContext): Promise<any> {
        const source = await context.evaluate(this.expression.value[0], { sourcePath });
        const target = await context.evaluate(this.expression.value[1], { sourcePath });
        return source !== target;
    }
}
